export default {
    selectSize: 'mini',
    buttonSize: 'mini',
    radioSize: 'mini',
    attendanceType: ["准时", "迟到", "请假", "缺勤"],
    leaveType: ['事假', '病假'],
    attendanceTypeColor: ['#33D8D9', '#FFB927', '#326EE5', '#F9855D']
}